import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { FilterRequest, Response, OfferStatus } from '@core/api';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class OfferStatusService {
  constructor(private http: HttpClient) { }

  list(request?: FilterRequest): Observable<Response<OfferStatus[]>> {
    return this.http.post<Response<OfferStatus[]>>(environment.apiUrl + '/api/OfferStatus/List', request);
  }
}
